import React from 'react';
import Icon from '../Icon';
import { tie } from '../page/typography';

/**
 * Першоджерела — картками з адресою сайту під назвою акта.
 *
 * Раніше це були три рядки дрібного підкресленого тексту в самому низу,
 * під блоком «Чим ми можемо допомогти», — їх легко було сприйняти за
 * примітку. А для юридичного тексту це головний доказ: читач, який
 * вирішує долю своєї ліцензії, має звірити норму сам, а не вірити нам на
 * слово. Адресу сайту видно одразу — ще до кліку зрозуміло, що посилання
 * веде на офіційний текст закону, а не на чийсь переказ.
 *
 * Стрілка навскіс — знак, що сторінка відкриється окремо; для диктора це
 * сказано словами.
 */
const hostOf = (href) => {
  try {
    return new URL(href).hostname;
  } catch (e) {
    return '';
  }
};

const SourceList = ({ sources = [] }) => (
  <ul className="list-none m-0 p-0 space-y-3">
    {sources.map((source) => (
      <li key={source.href}>
        <a
          href={source.href}
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5 hover:border-teal-300 hover:shadow-sm transition-[border-color,box-shadow] duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-700 focus-visible:ring-offset-2"
        >
          <span
            className="flex-shrink-0 w-10 h-10 rounded-xl border border-slate-200 bg-slate-50 text-teal-700 flex items-center justify-center group-hover:border-teal-200 group-hover:bg-teal-50 transition-colors duration-200"
            aria-hidden="true"
          >
            <Icon name="fa-file-contract" />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block font-medium leading-snug text-slate-900 group-hover:text-teal-800 transition-colors duration-200">
              {tie(source.label)}
            </span>
            <span className="mt-1.5 inline-flex items-center gap-1.5 text-sm font-semibold text-teal-700">
              {hostOf(source.href)}
              <Icon
                name="fa-arrow-right"
                className="-rotate-45 text-xs transition-transform duration-200 motion-reduce:transition-none group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </span>
            <span className="sr-only"> (відкривається в новій вкладці)</span>
          </span>
        </a>
      </li>
    ))}
  </ul>
);

export default SourceList;
